import React from 'react';
import {Result, Button} from "antd";
import {injectIntl} from 'react-intl'

const Route404 = props => {
	return <Result
		status="404"
		title="404"
		subTitle={props.intl.messages['DBQ_MYZDDY'] || "对不起，没有找到对应页面"}
		extra={<Button type="primary" href={'/home'}>{props.intl.messages['FanHuiShouYe'] || '返回首页'}</Button>}
	/>
};

export default injectIntl(Route404)
